/**
 * ****************************************************************************
 * @description     :   Repository for Search Box Component
 * @created at      :   2025/06/15
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from '@/utils/repository';

const resource = 'move';

/**
 * Repository for Search Box
 */
export default {
    /**
     * Get search suggestions from API with keyword support
     * Uses SPC_GET_FAQ_SUGGEST_SEARCH_INQ1 stored procedure
     * @param {Object} params - Parameters including keyword
     * @returns {Promise} - API response with search suggestions
     */
    getSuggestions(params = {}) {
        const url = `${resource}/CUS_Faq/suggestions`;
        return repository
            .get(url, { params })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.error('Error fetching suggestions:', error);
                throw error;
            });
    },

    /**
     * Update keyword count when suggestion is clicked
     * Uses SPC_UPDATE_FAQ_KEYWORD_COUNT stored procedure
     * @param {Object} params - Parameters including keywordId
     * @returns {Promise} - API response with update result
     */
    updateKeywordCount(params = {}) {
        const url = `${resource}/CUS_Faq/updateKeywordCount`;
        return repository
            .post(url, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                // Silent handling - log but don't rethrow to avoid blocking user interaction
                console.warn('Repository: updateKeywordCount API call failed (silent):', error.message || error);

                // Return a structured error response instead of throwing
                return {
                    data: {
                        Code: 500,
                        Message: error.response?.data?.Message || error.message || 'API call failed',
                        Data: null
                    }
                };
            });
    },

    /**
     * Log FAQ page access count
     * Uses SPC_FAQ_ACCESS_LOG_ACT1 stored procedure
     * @returns {Promise} - API response with log result
     */
    logAccess() {
        const url = `${resource}/CUS_Faq/logAccess`;
        return repository
            .post(url, {})
            .then((response) => {
                return response;
            })
            .catch((error) => {
                // Silent handling - log but don't rethrow
                console.warn('Repository: logAccess API call failed (silent):', error.message || error);
                return {
                    data: {
                        Code: 500,
                        Message: error.response?.data?.Message || error.message || 'API call failed',
                        Data: null
                    }
                };
            });
    }
};
